import { createContext, MutableRefObject } from 'react';
import { EntityHeaderConfig } from './types';

export type EntityHeaderContextValue = {
  configRef: MutableRefObject<EntityHeaderConfig | null>;
  subscribe: (callback: () => void) => () => void;
  notify: () => void;
};

export const EntityHeaderContext = createContext<EntityHeaderContextValue | null>(null);
